import { render } from "./MenuLevel1.vue?vue&type=template&id=98b7c978&ts=true"
import script from "./MenuLevel1.vue?vue&type=script&lang=ts"
export * from "./MenuLevel1.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__